import { List } from 'immutable'

export default List(['01', '02', '03', '04', '05', '06', '07', '90'])
